import Vue from 'vue';
import {
  Dialog,
  Pagination,
  Button,
  Select,
  Row,
  Col,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Option,
  OptionGroup,
  Input,
  Table,
  TableColumn,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Transfer,
  Switch,
  DatePicker,
  TimeSelect,
  TimePicker, InputNumber, Calendar,
  Tree, BreadcrumbItem, Loading, Popover, Card, Message, Tag,DropdownMenu,
  Radio, RadioGroup, Breadcrumb, Tooltip,ColorPicker,Dropdown,DropdownItem,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import iview from 'iview';
import store from './store';

import 'iview/dist/styles/iview.css';

import api from './api';
import common from './common';

import { router } from './router';
import App from './App.vue';
import echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Select);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Transfer);
Vue.use(Switch);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Tree);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Loading);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Card);
Vue.use(Tag);
Vue.use(ColorPicker);
Vue.use(Calendar);

Vue.prototype.$message = Message;

function hookInstall (instance, name) {
  instance.install = function (_Vue) {
    _Vue.prototype[name] = this;
  };
  return instance;
}
Vue.use(hookInstall(new Vue(), 'eventHub')); // 事件中心

Vue.config.productionTip = false;

Vue.use(iview);

// 对接国家虚仿平台
import ILab from "@/ILab/ILab.js";
const ILabItem  = new ILab();
Vue.prototype.$ILab = ILabItem


// 加载自定义插件
function installPlugin(plugin, name) {
  const p = plugin;
  p.install = function () {
    Vue.prototype[name] = this;
  };
  Vue.use(plugin);
}

installPlugin(api, '$api'); // api注册到全局
installPlugin(common, 'com'); // 公共函数注册到全局

window.RAdmin = null;
window.RAdmin = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
